import { defaultTheme } from 'react-admin';
import merge from 'lodash/merge';
import { createTheme } from '@mui/material/styles'; //  MUI v5 import

const CustomTheme = createTheme(merge({}, defaultTheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#6b489d',
            light: '#9c7bc7',
            dark: '#43276b',
        },
        secondary: {
            main: '#9c27b0',
            light: '#d05ce3',
            dark: '#6a0080',
            contrastText: '#fff',
        },
        error: {
            main: '#f44336',
            light: '#e57373',
            dark: '#d32f2f',
            contrastText: '#fff',
        },
        warning: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: '#000',
        },
        info: {
            main: '#2196f3',
            light: '#64b5f6',
            dark: '#1976d2',
            contrastText: '#fff',
        },
        success: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: '#fff',
        },
    },
    sidebar: {
    closedWidth: 50,
    width: 200
},
    typography: {
    fontSize: 12
},
    components: {
    ...defaultTheme.components,

    RaDatagrid: {
        styleOverrides: {
            root: {
                backgroundColor: "white",
                "& .RaDatagrid-headerCell": {
                    backgroundColor: "#ebecf3",
                    fontWeight: 'bold',
                },
            }
        }
    },

    RaSidebar: {
        styleOverrides: {
            root: {
                backgroundColor: "#ebecf3",
                "& .RaSidebar-fixed": {
                    backgroundColor: "#ebecf3",
                    scrollbarWidth: 'thin'
                },
            }
        }
    },

    RaBulkActionsToolbar: {
        styleOverrides: {
            root: {
                "& .RaBulkActionsToolbar-toolbar": {
                    position: 'inherit'
                },
            }
        }
    },

    RaLabeled: {
        styleOverrides: {
            root: {
                "& .RaLabeled-label": { //  corrected selector
                    fontSize: "0.90em",
                    fontWeight: 800
                }
            },
        }
    },

    RaLayout: {
        styleOverrides: {
            root: {
                ".RaLayout-content": {
                    marginLeft: "5px",
                },
            },
        },
    },

    //  moved old overrides into components
    MuiAppBar: {
        styleOverrides: {
            root: {
                backgroundColor: '#1976d2', // standard MUI blue
                color: '#fff',
            },
        },
    },

    MuiDialog: {
        styleOverrides: {
            paperWidthSm: {
                maxWidth: 'unset',
            },
        },
    },

    RaUserMenu: {
        styleOverrides: {
            avatar: {
                border: '1px solid white',
                width: 20,
                height: 20,
            },
        },
    },

    RaLoadingIndicator: {
        styleOverrides: {
            loadedIcon: { display: 'none' },
            loader: { display: 'none' },
        },
    },
}
}));

export default CustomTheme;
